import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props extends React.PropsWithChildren {
  title: string
  /** The content sits in a bordered card by default; a list page does without */
  plain?: boolean
}

export const PageWrapper: React.FC<Props> = ({
  title,
  plain = false,
  children,
}) => (
  <>
    <div className={css.page_title}>{title}</div>
    <div className={clsJoin(css.page_content, plain && css.plain)}>
      {children}
    </div>
  </>
)
